var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { CompanyService } from '~/services/management-service/company.service';
import { Emit, Prop } from 'vue-property-decorator';
import CommissionRange from "~/components/system-manage/outsource-commission/commission-range.vue";
import { CommissionStrategyService } from "~/services/domain-service/commission-strategy.service";
import { ProductService } from '~/services/domain-service/product.service';
var AddStrategy = /** @class */ (function (_super) {
    __extends(AddStrategy, _super);
    function AddStrategy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 产品类型
        _this.productTypeSet = [];
        _this.model = {
            strategyName: '',
            commonState: 'ENABLED',
            commissionStrategyType: 'NUMBER',
            strategyType: 'ENABLED',
        };
        _this.rules = {
            strategyName: [{ required: true, message: '佣金比例不能为空', trigger: 'blur' }],
            commonState: [{ required: true, message: '请选择状态', trigger: 'change' }],
            commissionStrategyType: [{ required: true, message: '请选择佣金类型', trigger: 'change' }],
            strategyType: [{ required: true, message: '请选择策略设置', trigger: 'change' }]
        };
        return _this;
    }
    Object.defineProperty(AddStrategy.prototype, "propData", {
        get: function () {
            return {
                commissionStrategyType: this.model.commissionStrategyType,
                strategyType: this.model.strategyType,
                productTypeSet: this.productTypeSet,
                isView: this.isView
            };
        },
        enumerable: false,
        configurable: true
    });
    AddStrategy.prototype.refreshData = function () { };
    AddStrategy.prototype.close = function () { };
    AddStrategy.prototype.mounted = function () {
        this.selectProductList();
    };
    /**
     * 获取产品类型下拉列表
     */
    AddStrategy.prototype.selectProductList = function () {
        var _this = this;
        this.productService.selectProductList().subscribe(function (data) { return _this.productTypeSet = data; });
    };
    /**
     * 确定
     */
    AddStrategy.prototype.submit = function () {
        var _this = this;
        if (this.dialogType === "VIEW") {
            this.close();
            return;
        }
        var form = this.$refs["add-strategy"];
        form.validate(function (valid) {
            if (!valid)
                return;
            // 校验佣金范围
            var comp = _this.$refs["commission-range"];
            var compData = comp.getDataSet();
            if (compData.unpass) {
                _this.$message.error(compData.message);
                return;
            }
            var action = '';
            var params = __assign(__assign({}, _this.model), { commissionStrategyDetailModelList: compData.map(function (v) {
                    return {
                        productId: v.productId || '',
                        productName: v.productName || '',
                        overduePeriodStart: (v.overduePeriodStart || v.overduePeriodStart === 0) ? v.overduePeriodStart : '',
                        overduePeriodEnd: (v.overduePeriodEnd || v.overduePeriodEnd === 0) ? v.overduePeriodEnd : '',
                        recoverRateStart: _this.getNumberDivide100(v.recoverRateStart),
                        recoverRateEnd: _this.getNumberDivide100(v.recoverRateEnd),
                        commissionRate: _this.getNumberDivide100(v.commissionRate),
                        commissionAmount: (v.commissionAmount || v.commissionAmount === 0) ? v.commissionAmount : '',
                    };
                }) });
            if (_this.dialogType === "ADD") {
                action = "insertCommissionStrategy";
            }
            if (_this.dialogType === "EDIT") {
                action = "editCommissionStrategy";
                params.id = _this.rowData.id;
            }
            _this.commissionStrategyService[action](params).subscribe(function (data) {
                _this.refreshData();
                _this.close();
                _this.$message.success("操作成功");
            });
        });
    };
    /**
     * 取消
     */
    AddStrategy.prototype.cancel = function () {
        var form = this.$refs["add-strategy"];
        form.resetFields();
        var comForm = this.$refs["commission-range"];
        comForm.refresh();
        this.close();
    };
    /**
     * 弹框打开时初始化页面信息
     */
    AddStrategy.prototype.refresh = function () {
        var _this = this;
        var comForm = this.$refs["commission-range"];
        if (!this.rowData) {
            comForm.refresh();
            return;
        }
        this.model.strategyName = this.rowData.strategyName;
        this.model.commonState = this.rowData.commonState;
        this.model.commissionStrategyType = this.rowData.commissionStrategyType;
        this.commissionStrategyService.getCommissionDetailsById({ id: this.rowData.id }).subscribe(function (data) {
            _this.model.strategyType = data.find(function (v) { return v.productId; }) ? "ENABLED" : "DISABLED";
            var tempData = data.map(function (v) {
                return {
                    productId: v.productId || '',
                    productName: v.productName || '',
                    overduePeriodStart: (v.overduePeriodStart || v.overduePeriodStart === 0) ? v.overduePeriodStart : '',
                    overduePeriodEnd: (v.overduePeriodEnd || v.overduePeriodEnd === 0) ? v.overduePeriodEnd : '',
                    recoverRateStart: _this.getNumberMultiply100(v.recoverRateStart),
                    recoverRateEnd: _this.getNumberMultiply100(v.recoverRateEnd),
                    commissionRate: _this.getNumberMultiply100(v.commissionRate),
                    commissionAmount: (v.commissionAmount || v.commissionAmount === 0) ? v.commissionAmount : '',
                };
            });
            comForm.refresh(tempData);
        });
    };
    Object.defineProperty(AddStrategy.prototype, "isView", {
        get: function () {
            return this.dialogType === "VIEW";
        },
        enumerable: false,
        configurable: true
    });
    AddStrategy.prototype.getNumberDivide100 = function (val) {
        if (val && !Number.isNaN(val)) {
            return (val / 100).toFixed(2);
        }
        else if (val === 0) {
            return 0;
        }
        else {
            return '';
        }
    };
    AddStrategy.prototype.getNumberMultiply100 = function (val) {
        if (val && !Number.isNaN(val)) {
            return (val * 100).toFixed(2);
        }
        else if (val === 0) {
            return 0;
        }
        else {
            return '';
        }
    };
    __decorate([
        Dependencies(CompanyService)
    ], AddStrategy.prototype, "companyService", void 0);
    __decorate([
        Dependencies(CommissionStrategyService)
    ], AddStrategy.prototype, "commissionStrategyService", void 0);
    __decorate([
        Dependencies(ProductService)
    ], AddStrategy.prototype, "productService", void 0);
    __decorate([
        Prop({ required: true, default: 'ADD' })
    ], AddStrategy.prototype, "dialogType", void 0);
    __decorate([
        Prop()
    ], AddStrategy.prototype, "rowData", void 0);
    __decorate([
        Emit('refreshData')
    ], AddStrategy.prototype, "refreshData", null);
    __decorate([
        Emit('close')
    ], AddStrategy.prototype, "close", null);
    AddStrategy = __decorate([
        Component({
            components: {
                CommissionRange: CommissionRange
            },
        })
    ], AddStrategy);
    return AddStrategy;
}(Vue));
export default AddStrategy;
